import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ReactPlayer from 'react-player'
import { connect } from 'react-redux'
import {isMobile} from 'react-device-detect'

import { setAttribute } from '../../actions/registration'

class HomeStepFour extends Component {

  onClickBack() {
    const stepThree = this.props.registration.selectedActions.find((item) => {
      return (typeof item.registro !== 'undefined')
    })
    if (stepThree) {
      this.props.history.push('/step3')
    } else {
      this.props.history.push('/step2')
    }
  }

  componentDidMount() {
    if (!this.props.startOk) {
      this.props.history.push('/')
    }
  }

  onClickSkip(){
    this.props.history.push('/term')
  }

  renderVideo() {
    if(isMobile) {
      return (
        <ReactPlayer
          url="/video/video.mp4"
          width="100%"
          controls
        />
      )
    }
    return (
      <ReactPlayer
        url="/video/video2.mp4"
        width="100%"
        controls
      />
    )
  }

  render() {
    return (
      <div>
        <div className="modal-header">
          <div className="container">
            <div className="img-voltar">
              <a onClick={this.onClickBack.bind(this)}>
                <img src="images/voltar.png" alt="Voltar"/>
              </a>
            </div>
            <div className="sobre">Saiba mais sobre o trabalho voluntário</div>
          </div>
        </div>
        <div className="modal-body">
          <div className="container">
            <div className="chamada-modal">
              <p className="detalhe">Opa! Que tal aprender um pouco mais sobre como o voluntariado funciona?</p>
            </div>
            <div className="area-video">
              {this.renderVideo()}
            </div>
            <div className="bt-fechar-tudo">
              <div className="skip"><a onClick={this.onClickSkip.bind(this)}><b>Continuar</b></a></div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

HomeStepFour.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  registration: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    telefone: PropTypes.string,
    city: PropTypes.string,
  }).isRequired,
  setAttribute: PropTypes.func.isRequired,
  startOk: PropTypes.bool.isRequired,
}

HomeStepFour.defaultProps = {
  history: {
    push: () => { },
  },
}


const mapStateToProps = state => ({
  registration: state.registration,
  startOk: !!state.registration['start-ok'],
})

const mapDispatchToProps = {
  setAttribute,
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeStepFour)



// WEBPACK FOOTER //
// ./src/components/home/StepFour.js